export const DDC_VIDEO_PLAY = 'ddc.video.play';
export const VIDEO_PLAY = 'video-play';

function play(event, autoplay = false) {
	const {
		currentTarget: element,
		currentTarget: {
			duration: videoDuration = '',
			currentSrc: videoSource
		} = {}
	} = event;
	// TODO: Does currentSrc work instead?
	// const videoSource = $(this).find('source').attr('src');

	return {
		eventType: DDC_VIDEO_PLAY,
		eventData: {
			autoplay,
			element,
			videoSource,
			videoDuration,
			fileType:
				typeof videoSource === 'string'
					? videoSource.split('.').pop()
					: ''
		},
		overrides: {
			eventType: VIDEO_PLAY
		}
	};
}

export default play;
